import { Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import FloatingContactButtons from "./components/FloatingContactButtons";
import MobileBottomNav from "./components/MobileBottomNav";

import Home from "./pages/home/Home";
import Mp from "./pages/mp/Mp";
import Cg from "./pages/CG/Cg";
import World from "./pages/World/World";
import Videsh from "./pages/videsh/World";
import Education from "./pages/Education/Education";
import Contact from "./pages/contact/Contact";
import Photos from "./pages/gallery/Photos";
import Videos from "./pages/gallery/Videos";
import About from "./pages/about/About";
import Bundeli from "./pages/bundeli/Bundeli";
import Hindi from "./pages/hindi/Hindi";
import Blog from "./pages/blog/Blog";
import BlogDetail from "./pages/blog/BlogDetail";
import Team from "./pages/team/Team";
import Ad from "./pages/ad/Ad";
import NewsDetail from "./pages/news/NewsDetail";
import Sports from "./pages/sports/sports";
import Dharm from "./pages/Dharm/dharm";
import Cinema from "./pages/cinema/cinema";
import Category from "./pages/category/Category";
import MobileNewsCategories from "./pages/category/MobileNewsCategories";
import WebStoryDetail from "./pages/webstories/WebStoryDetail";
import Terms from "./pages/terms/Terms";
import Privacy from "./pages/privacy/Privacy";
import SearchPage from "./pages/search/SearchPage";

function App() {
  const location = useLocation();
  const isWebStoryDetail = location.pathname.startsWith("/web-stories/");

  return (
    <>
      <ScrollToTop />
      {!isWebStoryDetail && <Header />}

      <main className="app-main bg-gray-50">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mp" element={<Mp />} />
          <Route path="/cg" element={<Cg />} />
          <Route path="/world" element={<World />} />
          <Route path="/videsh" element={<Videsh />} />
          <Route path="/education" element={<Education />} />
          <Route path="/gallery/photos" element={<Photos />} />
          <Route path="/gallery/videos" element={<Videos />} />
          <Route path="/bundeli" element={<Bundeli />} />
          <Route path="/hindi" element={<Hindi />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/ad" element={<Ad />} />
          <Route path="/news/:id" element={<NewsDetail />} />
          <Route path="/news-categories" element={<MobileNewsCategories />} />
          <Route path="/web-stories/:id" element={<WebStoryDetail />} />
          <Route path="/sports" element={<Sports />} />
          <Route path="/dharm" element={<Dharm />} />
          <Route path="/cinema" element={<Cinema />} />
          <Route path="/category/:slug" element={<Category />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/search" element={<SearchPage />} />
        </Routes>
      </main>

      {!isWebStoryDetail && (
        <>
          <Footer />
          <FloatingContactButtons />
          <MobileBottomNav />
        </>
      )}
    </>
  );
}

export default App;
